/**
 * 存储工厂 —— UI 层与 service 层拿存储实例的唯一入口。
 * 库名按 DID 分库（ARCH §8.1），切换身份时自动换库。
 */

import type { IStorage } from './IStorage';
import { IndexedDbStorage } from './IndexedDbStorage';
import { dbNameFor } from './IStorage';

/** 默认实现（T 系列任务如需换实现，只改这里）。 */
export function createStorage(): IStorage {
  return new IndexedDbStorage();
}

export { dbNameFor, IndexedDbStorage };
export type { IStorage };
